import { observer } from 'mobx-react-lite';
import { View, ViewStyle } from 'react-native';
import { CircularButton } from '../buttons/circular-button/CircularButton';
import { SecondaryButton } from '../buttons/secondary-button/SecondaryButton';
import { PrimaryButton } from '../buttons/primary-button/PrimaryButton';
import TextLato from '../text/text-lato/TextLato';
import { useBSSharePhotos } from './BottomSheetSharePhotos.logic';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from '../buttons/circular-button/CircularButton.constants';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { ICON_NAMES } from '../icon/icon.helper';
import { style } from './BottomSheetSharePhotos.style';
import { PhotosContainer } from '../photos-container/PhotosContainer';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';

export const BottomSheetSharePhotos = observer(({ bsStyle }: { bsStyle: ViewStyle }) => {
  const { i18n, data, onPressDecline, onPressConfirm } = useBSSharePhotos();
  return (
    <BottomSheetScrollView contentContainerStyle={bsStyle}>
      <View style={style.container}>
        <View style={style.iconContainer}>
          <CircularButton
            size={CIRCULAR_BUTTON_SIZES.SMALL}
            type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
            iconName={ICON_NAMES.Close}
            focusGroup={FocusGroups.BOTTOM_SHEET}
            focusId=""
            focusOrder={0}
            iconStyle={style.iconClose}
            onPress={onPressDecline}
          />
        </View>
        <View style={style.content}>
          <PhotosContainer urls={data.notificationFiles.map(file => file.thumbnailUrl)} />
          <View style={style.textContainer}>
            <TextLato style={style.title}>{i18n.t('toast-share-photos:title')}</TextLato>
            <TextLato style={style.description}>{i18n.t('toast-share-photos:description')}</TextLato>
          </View>
        </View>
        <View style={style.ctaContainer}>
          <SecondaryButton
            focusGroup={FocusGroups.BOTTOM_SHEET}
            focusId=""
            focusOrder={1}
            onPress={onPressDecline}
            text={i18n.t('toast-share-photos:cta-decline')}
          />
          <PrimaryButton
            onPress={onPressConfirm}
            text={i18n.t('toast-share-photos:cta-confirm')}
            focusGroup={FocusGroups.BOTTOM_SHEET}
            focusId=""
            focusOrder={2}
          />
        </View>
      </View>
    </BottomSheetScrollView>
  );
});
